import React, { useState, useEffect, useRef } from "react";
import { useApp } from "app/contexts/AppContext";
import { Button } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";
import { isPublicRoute } from "app/routes";
import companyLogo from "../../../images/morphLogo.svg";
import defaultAvatar from "../../../images/avatar.svg";
import UserMenu from "./UserMenu";
import BookingLinkPopover from "./BookingLinkPopover";
import "./globalNavBar.css";

const GlobalNavBar = () => {
  const {
    user: { profile },
    device: { isMobile, isTablet },
    sidebar: { toggle, forceOverlay },
  } = useApp();
  const location = useLocation();
  const menuRef = useRef(null);
  const bookingLinkRef = useRef(null);

  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showBookingLink, setShowBookingLink] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isInsideModal = event.target.closest(".modal");
      if (isInsideModal) return;

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
      if (
        bookingLinkRef.current &&
        !bookingLinkRef.current.contains(event.target)
      ) {
        setShowBookingLink(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUserIconClick = () => {
    setShowUserMenu(!showUserMenu);
  };

  const closeUserMenu = () => {
    setShowUserMenu(false);
  };

  const showBurgerMenu = isMobile || isTablet || forceOverlay;

  // background-survey is a semi-public route because some layout on this page looks like a public page
  const isPublic =
    isPublicRoute(location.pathname) ||
    location.pathname === "/background-survey";

  const handleBurgerClick = () => {
    toggle();
  };

  return (
    <nav className={`navbar${isPublic ? " public" : ""}`}>
      <div className="navbar-left">
        {showBurgerMenu && !isPublic && (
          <button
            className="burger-menu-button"
            onClick={handleBurgerClick}
            aria-label="Toggle menu"
          >
            <List size={24} />
          </button>
        )}
        <a href="/" className="navbar-brand">
          <img src={companyLogo} alt="Logo" className="navbar-logo" />
        </a>
      </div>

      <div className="navbar-right">
        {!isPublic && (
          <div className="booking-link-wrapper" ref={bookingLinkRef}>
            <Button
              variant="outline-primary"
              size="sm"
              style={{ padding: "4px 8px", borderRadius: "3.2px" }}
              onClick={() => setShowBookingLink(!showBookingLink)}
            >
              Booking Link
            </Button>
            <BookingLinkPopover
              show={showBookingLink}
              onClose={() => setShowBookingLink(false)}
            />
          </div>
        )}
        {!isPublic && (
          <div className="user-profile-wrapper" ref={menuRef}>
            <button
              className="user-profile-button"
              onClick={handleUserIconClick}
            >
              <img
                src={profile?.profile_image?.presigned_url || defaultAvatar}
                alt="Profile"
                className="user-profile-icon"
                onError={(e) => {
                  e.target.src = defaultAvatar;
                }}
              />
            </button>

            <UserMenu
              show={showUserMenu}
              onClose={closeUserMenu}
              profileImage={profile?.profile_image?.presigned_url}
              defaultAvatar={defaultAvatar}
            />
          </div>
        )}
      </div>
    </nav>
  );
};

export default GlobalNavBar;
